module.exports = __webpack_public_path__ + "img/sj1_mb.2c3fc7aa.jpg";